import { ChatMessage, ChatRequest, ChatResponse } from '../types/chat';
import { apiClient } from './apiClient';

export class ChatService {
  /**
   * Отправляет текстовое сообщение в чат
   */
  static async sendMessage(request: ChatRequest): Promise<ChatResponse> {
    const response = await apiClient.post('/chat/message', request);
    return response.data;
  }

  /**
   * Отправляет сообщение с файлами
   */
  static async sendMessageWithFiles(
    message: string,
    model: string,
    files: File[]
  ): Promise<ChatResponse> {
    const formData = new FormData();
    formData.append('message', message);
    formData.append('model', model);
    
    files.forEach(file => {
      formData.append('files', file);
    });

    const response = await apiClient.post('/chat/message-with-files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  }

  /**
   * Получает список доступных моделей
   */
  static async getAvailableModels(): Promise<string[]> {
    const response = await apiClient.get('/chat/models');
    return response.data;
  }

  /**
   * Конвертирует файл в base64
   */
  static async fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        // Убираем префикс data:...;base64,
        const base64 = result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  /**
   * Конвертирует base64 в файл
   */
  static base64ToFile(base64: string, filename: string, contentType: string): File {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });
    return new File([blob], filename, { type: contentType });
  }
}
